import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const StressReductionByCategoryChart: React.FC = () => {
  const data = {
    labels: ['Debt Processing', 'Claim Administration', 'Past Due Items', 'Support Services', 'Financial Education'],
    datasets: [
      {
        label: 'Before',
        data: [3.2, 3.0, 3.4, 2.8, 2.9],
        backgroundColor: '#ef4444',
        borderColor: '#ef4444',
        borderWidth: 0
      },
      {
        label: 'After',
        data: [4.1, 4.3, 4.2, 4.0, 4.1],
        backgroundColor: '#10b981',
        borderColor: '#10b981',
        borderWidth: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
        labels: {
          color: '#64748b',
          font: {
            size: 12
          },
          padding: 20
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 12,
        callbacks: {
          label: function(context: any) {
            return `${context.dataset.label}: ${context.parsed.y}/5.0`;
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 11
          },
          maxRotation: 45
        }
      },
      y: {
        grid: {
          color: 'rgba(148, 163, 184, 0.1)'
        },
        ticks: {
          color: '#94a3b8',
          font: {
            size: 11
          }
        },
        min: 0,
        max: 5
      }
    }
  };

  return (
    <div className="h-80">
      <Bar data={data} options={options} />
    </div>
  );
};

export default StressReductionByCategoryChart;